import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, Signal, TemplateRef, viewChild, inject } from '@angular/core';
import { TitleCasePipe } from '@angular/common';
import { TranslateDirective } from '@ngx-translate/core';
// eslint-disable-next-line td-wb-rules/uirouter-import-rule
import { UIView } from '@uirouter/angular';
import { AddressModalService } from '../../../features/address/address-modal.service';

import { ConfirmButtonOkComponent } from '../../../components/confirm/confirm-button-ok.component';
import { ConfirmButtonCancelComponent } from '../../../components/confirm/confirm-button-cancel.component';
import { ModalHeaderCloseButtonComponent } from '../../../components/modal/components/modal-header/modal-header-close-button.component';
import { ConfirmButtonsComponent } from '../../../components/confirm/confirm-buttons.component';
import { ConfirmTitleComponent } from '../../../components/confirm/confirm-title.component';
import { ModalService } from '../../../components/modal/modal.service';
import { ModalCloseEvent } from '../../../components/modal/components/modal-close/modal-close-button.directive';
import { ModalCloseReason } from '../../../components/modal/modal.domain';
import { ConfirmComponent } from '../../../components/confirm/confirm.component';
import { ModalHeaderButtonsComponent } from '../../../components/modal/components/modal-header/modal-header-buttons.component';
import { ModalHeaderComponent } from '../../../components/modal/components/modal-header/modal-header.component';
import { ConfirmBodyComponent } from '../../../components/confirm/confirm-body.component';
import { W8BenFormAnalyticsService } from '../w8ben-form-analytics.service';
import { W8BenFormService } from '../w8ben-form.service';

@Component({
  selector: 'td-wb-w8ben-container',
  templateUrl: 'w8ben-form-container.component.html',
  styleUrls: ['w8ben-form-container.component.scss'],
  imports: [
    TranslateDirective,
    ConfirmComponent,
    ConfirmTitleComponent,
    ConfirmBodyComponent,
    ConfirmButtonsComponent,
    ConfirmButtonCancelComponent,
    ConfirmButtonOkComponent,
    ModalHeaderComponent,
    ModalHeaderButtonsComponent,
    ModalHeaderCloseButtonComponent,
    UIView
  ],
  providers: [W8BenFormService, TitleCasePipe]
})
export class W8BenFormContainerComponent implements OnInit, OnDestroy, AfterViewInit {
  private readonly modalService = inject(ModalService);
  private readonly w8BenFormAnalyticsService = inject(W8BenFormAnalyticsService);
  private readonly addressModalService = inject(AddressModalService);
  private readonly elementRef = inject(ElementRef);

  private readonly confirmTemplate: Signal<TemplateRef<unknown> | undefined> = viewChild<TemplateRef<unknown>>('confirmTemplate');

  ngOnInit(): void {
    this.addressModalService.movePca(this.elementRef.nativeElement);
  }

  ngOnDestroy(): void {
    this.addressModalService.resetPca();
  }

  ngAfterViewInit(): void {
    const topModal = this.modalService.getTopModal();

    topModal?.onCloseRequest.subscribe((event: ModalCloseEvent) => {
      if (event.closeReason === ModalCloseReason.ESC && event.close) {
        event.close(event.closeReason);
      } else {
        if (this.confirmTemplate()) {
          this.w8BenFormAnalyticsService.emitLinkClickEvent('close');
          this.openDismissDialog(this.confirmTemplate(), event);
        }
      }
    });

    this.w8BenFormAnalyticsService.setModalId(`${topModal?.id ?? 'td-wb-w8ben-form'}-title`);
  }

  openDismissDialog(template: TemplateRef<unknown>, event: ModalCloseEvent): void {
    const confirmModal = this.modalService.open(template, {
      size: 'extra-small',
      id: 'td-wb-w8ben-container-dismiss-dialog'
    });

    confirmModal.afterClose().subscribe((result: unknown): void => {
      if (result === 'OK' && event.close) {
        this.w8BenFormAnalyticsService.emitLinkClickEvent('yes-dismiss');
        event.close(event.closeReason);
      } else {
        this.w8BenFormAnalyticsService.emitLinkClickEvent('no-continue');
      }
    });
  }
}

